import { gql } from "../../../../../gql/__generated__/gql";

export const CREATE_PRODUCT = gql(`
  mutation createProduct($product: ProductInput!) {
    createProduct(product: $product)
  }
`);

export const UPDATE_PRODUCT = gql(`
  mutation updateProduct($id: String!, $product: ProductInput!) {
    updateProduct(id: $id, product: $product)
  }
`);
